import useOrientation from "./useOrientation";

export default function useIsPortrait() {
  return useOrientation() === "portrait";
}
